setBlogSidebar();
$(window).scroll(function(){   
   var x = $(this).scrollTop();
  $('.round_scroll img').css('transform', 'rotate('+x+'deg)');   
  
  if(x < $(window).height()){
    $('.back_to_top').addClass('hide');  
  }else{
    $('.back_to_top').removeClass('hide');
  }
  
});



$(function(){
  
  setInterval(function(){
    if($(".pxs-newsletter input[type=email]").length > 0) {
      $(".pxs-newsletter input[type=email]").attr("autocomplete", "off");
    }
  }, 1000);
  
  var x = 2;
  setInterval(function(){
    // scroll_auto(x);
    x = x + 1;
   }, 20);
 
  $('.back_to_top').on('click', function(){
    $("html, body").animate({ scrollTop: 0 }, 600);
  });

  // $('.nav-item.last').on('click', function(e){
  //   e.preventDefault();
  //   $('.my-cart').addClass('my-cart-open');
  // });
  
  // quick view
  
  $('.quk_close, .quk_out').on('click', function(){
    $('.quick_view').fadeOut();
  });
 $('.quick_view_btn').on('click', function(){
   if($(window).width() > 767) {
    	$(this).closest('.product-inner').next('.quick_view').fadeIn();
   }
   else {
     //window.location.href = $(this).parent().next().attr("href");
     $(".quickViewContainer").empty();
     $(this).closest('.product-inner').next('.quick_view').clone().appendTo(".quickViewContainer");
     $('.quickViewContainer .quick_view').fadeIn();
   }
  });
  
  
  
  // subscription
  
  $('.sbs_chaeck').on('click', function(){
    if(!$(this).hasClass("stickyCheck")) {
    $('.sbs_chaeck').removeClass('active');
    $(this).addClass('active');
    var type = 'Subscribe';
    var productForm = $(this).closest("form[data-product-form]");
    
    var sp = productForm.find('li.active').attr("selling_plan_id") || '';
    productForm.find('input[name="selling_plan"]').attr("value",sp)
    if($(this).hasClass('sbs_one_time')){
      type = 'onetime';
      productForm.find('input[name="selling_plan"]').attr("value",'')
    }      
     select_subscripe(type)
    }
  });
  
  $('.sbs_list li').on('click', function(){
    $('.sbs_list li, .sbs_chaeck').removeClass('active');
    $(this).addClass('active');
    var productForm = $(this).closest("form[data-product-form]");
    var sp = productForm.find('li.active').attr("selling_plan_id") || '';
    productForm.find('input[name="selling_plan"]').attr("value",sp)
    
    $('.sbs_heading ').addClass('active');
    select_subscripe('Subscribe');
     
    var no = $(this).data('no');
    select_frequency(no);
  });
  
  
  function select_subscripe(type){
    if(type == 'onetime'){
      $('input[value="onetime"]').prop("checked", true).trigger("click");
    }else{     
      $('input[value="autodeliver"]').prop("checked", true).trigger("click");
    }    
  }
  
  function select_frequency(value){
    $('select.rc_select__frequency').val(value).trigger('change');
  }
  
  if($("body").hasClass("template-product")) {
    if($(".faqList").length > 0) {
      var arrow = $(".faqList").data('arrow');
      var html = '<span class="faqIcon"><img src="'+arrow+'" alt="#"></span>';
      $(".faqList .faqText h4").append(html);
    }
  }
  
  if($("#loginEmail").length > 0) {
    $("#signupEmail").val($("#loginEmail").val());
  }
  
  if($(".bottom_slider").length > 0) {
    $(".bottom_slider .slideshow--viewport").slick({
      arrows: true,
      autoplay: true,
      dots: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      lazyLoad: 'progressive',
      nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg class="svg-icon icon-arrow-thin-right " xmlns="http://www.w3.org/2000/svg" width="23" height="40" viewBox="0 0 23 40"><path fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" d="M17.427 20L0 2.57298L2.57298 0L22.573 20L2.57298 40L0 37.427L17.427 20Z"></path></svg></button>',
      prevArrow: '<button class="slick-prev slick-arrow" aria-label="Next" type="button" style=""><svg class="svg-icon icon-arrow-thin-right " xmlns="http://www.w3.org/2000/svg" width="23" height="40" viewBox="0 0 23 40"><path fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" d="M17.427 20L0 2.57298L2.57298 0L22.573 20L2.57298 40L0 37.427L17.427 20Z"></path></svg></button>',
    });
  }

  
  
  if($(".rc_layout__full").length > 0) {
    $(".rc_layout__full a").each(function(){
      if($.trim($(this).text()) == "Return to login") {
        $(this).text("Return to Account Page");
        $(this).attr("href", "/account/");
      }
    });
  }
  
  if($("body").hasClass("template-blog")) {
    setBlogSidebar();
  }
  
  if($(".pressSlider").length > 0) {
    $(".pressSlider").slick({
      dots: false,
      arrows: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      infinite: true,
      responsive: [
      {
        breakpoint: 650,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
        ]
    });
  }
  
});

$("#loginEmail").on("keyup", function(){
  $("#signupEmail").val($("#loginEmail").val());
});

//alert(window.innerWidth +" x "+ window.innerHeight);

function setBlogSidebar(){
  /*if($("body").hasClass("template-blog")) {
    var firstHeight = $(".blog-articles article:eq(0) .article-header").height();
    firstHeight = firstHeight + 33;
    $(".blog-sidebar").css({"margin-top":(firstHeight - 3)+"px"});
  }*/
  $(".blog-sidebar").css({"margin-top":(firstHeight - 3)+"px"});
  if($("body").hasClass("template-article")) {
    var firstHeight = $(".blog-article article:eq(0) .article-header").height();
    firstHeight = firstHeight + 33;
    $(".blog-sidebar").css({"margin-top":(firstHeight - 48)+"px"});
  }
}
$("body").on("click", ".blog-sidebar-tags-title", function(){
  if($(window).width() < 750) {
    if($("body").hasClass("template-blog")) {
      $(this).toggleClass("active");
      $(this).next().stop().slideToggle('fast');
    }
  }
  
});

/*
function scroll_auto(x){
  $('.pxs-newsletter-figure').css('transform', 'rotate('+x+'deg)');
}
*/

$("body").on("click", ".faqList .faqTitle", function(){
  $(this).stop().toggleClass("active");
  //$(this).next(".faqText").stop().slideToggle();
});
$("body").on("click", ".faqList .faqText h4", function(){
  $(this).stop().toggleClass("active");
  $(this).next("div").stop().slideToggle();
});


$("body").on("click", "#editAccountInfo", function(event){
	event.preventDefault();
  	$("#resetpassword").next().next().stop().hide();
  	$("#wishify").stop().hide();
  $("#add_address").stop().hide();
  	$("#resetpassword").stop().show();
});
$("body").on("click", "#show-wishlist", function(event){
  event.preventDefault();
  $("#wishify").next().stop().hide();
  $("#resetpassword").stop().hide();
  $("#add_address").stop().hide();
  $("#wishify").stop().show();
  
});

$("body").on("click", ".quk_list_img li", function(event){
  //console.log($(this).parent().prev().children("img").attr("src"));
  var img = $(this).data("img");
  $(this).parent().prev().children("img").attr("src", img);
});

$("body").on("click", "#notifyTrigger", function(event){
  event.preventDefault();
  $(".notify-popup").addClass("active");
});
$("body").on("click", "#close-notify", function(event){
  event.preventDefault();
  $(".notify-popup").removeClass("active");
});





function ovalSlider(num) {
  $(".hoverimg").css({"opacity": "0"});
  $(".hoverimg"+num).css({"opacity": "1"});
}


$(window).on("load", function(){
  $("html, body").animate({ scrollTop: 0 }, 10);
  if($(".productSlider").length > 0) {
    $(".productSlider").slick({
      autoplay: true,
      infinite: true,
      arrows: false,
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1
    });
  }
  if($("body").hasClass("template-product")) {
    setInterval(function(){
      if($(".notify-wrapper input[type='text']").length > 0) {
        $(".notify-wrapper input[type='text']").val($(".notify-popup").data("product"));
        //console.log("found");
      }
      else {
        //console.log("not found");
      }
    }, 2000);
  }
});
var xNum = 1;
$(window).on("load", function(event){
  if($(window).width() < 749) {
  setTimeout(function(){
  setInterval(function(){
        ovalSlider(xNum);
        ++xNum;
        if(xNum > 7) {
          xNum = 1;
        }
      }, 3000);
    }, 3000);
  }
});
$(window).on("load resize", function(event){
 	//console.log($(this).width());
  if($("body").hasClass("template-blog") || $("body").hasClass("template-article")) {
  	setBlogSidebar();
    console.log("article");
  }
  if($(this).width() > 749) {
    if($(".bottom_slider").next(".content-outer-wrap").length > 0) {
      $(".bottom_slider").next(".content-outer-wrap").appendTo(".bottom_slider");
    }
    if($(".custom_blog").length > 0) {
        $(".custom_blog ul.articles").slick('unslick');
    }
    if($(".featured-collection .product-list").length > 0) {
      $(".featured-collection .product-list").slick("unslick");
    }
    
  }
  else {
    
    if($(".template-product .ovalContainer").length > 0) {
      /*$(".template-product .ovalContainer").slick({
        autoplay: true,
        infinite: true,
        dots: false,
        arrows: false,
        fade: true
      });*/
    }
    
      if($(".bottom_slider > .content-outer-wrap").length > 0) {
        $(".bottom_slider > .content-outer-wrap").insertAfter(".bottom_slider");
      }
      if($(".custom_blog").length > 0) {
        $(".custom_blog ul.articles").slick({
          infinite: true,
          dots: true,
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1
        });
      }
      if($(".featured-collection ul.product-list").length > 0) {
        $(".featured-collection .product-list").slick({
          infinite: true,
          dots: true,
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1
        });
      }
    }
  if($(this).width() > 768) {
    if($(".productSection .logoList").hasClass("slick-slider")) {
      /*$(".productSection .logoList").slick('unslick');*/
    }
  }
  else {
    if($(".productSection .logoList").length > 0) {
      $(".scroll1").infiniteslide({
        speed: 50
      });
      /*$(".productSection .logoList").slick({
        speed: 3000,
        autoplay: true,
        autoplaySpeed: 0,
        centerMode: true,
        cssEase: 'linear',
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        initialSlide: 1,
        draggable: false,
        arrows: false,
        buttons: false
      });*/
      
    }
  }
});

 

function minusQty(_this) {
  var curQty = parseInt($.trim($(_this).next(".cart-mini-value").text()));
  if(curQty > 1) {
    curQty--;
    var itemId = parseInt($.trim($(_this).parent().attr("data-item-id")));
    updateMiniCarQty(itemId, curQty)
    $(_this).next(".cart-mini-value").text(curQty);
  }
  
  
}
function plusQty(_this) {
  var curQty = parseInt($(_this).prev(".cart-mini-value").text());
  curQty++;
  var itemId = parseInt($.trim($(_this).parent().attr("data-item-id")));
  console.log(itemId + " : ", curQty );
    updateMiniCarQty(itemId, curQty);
  $(_this).prev(".cart-mini-value").text(curQty);
  
}

function updateMiniCarQty(itemId, qty) {
 
  jQuery.ajax({
      type: 'POST',
      url: '/cart/change.js',
    data: 
    { id: itemId, quantity: qty },
      dataType: 'json',
    	beforeSend: function(){
      		
        },
      success: function() {
        	console.log("cart updated");
          $.getJSON('/cart.js').then(
            function(cart) {
              console.log(cart.item_count);
              //console.log(cart);
              $(".cart-mini-subtotal-value.money").text(Shopify.formatMoney(cart.items_subtotal_price));
              //$("data-price-item-id["+itemId+"]").text(cart.items[0].);
              
              
            }
          );
        
      },
      error: function() {
          
      }
    });
  
}



$("body").on("click", ".quick_view .qtyMinus", function(){
  var qty = $(".quick_view .product-quantity-input").val();
  if(qty > 1) {
    $(".quick_view .product-quantity-input").val(--qty);
  }
});
$("body").on("click", ".quick_view .qtyPlus", function(){
  var qty = $(".quick_view .product-quantity-input").val();
    $(".quick_view .product-quantity-input").val(++qty);
});



$("body").on("click", ".inputWrap .qtyMinus", function(){
  var qty = $(".product-quantity-input").val();
  if(qty > 1) {
    $(".product-quantity-input").val(--qty);
  }
});
$("body").on("click", ".inputWrap .qtyPlus", function(){
  var qty = $(".product-quantity-input").val();
    $(".product-quantity-input").val(++qty);
});


$("body").on("click", "h3.listHead", function(event){
	$(this).next("ul").stop().slideToggle();
  $(this).toggleClass("active");
});
$("body").on("click", "#show_signup", function(event){
  $("#customer-login").hide();
  $("#customer-create").show();
});
$("body").on("click", "#show_signin", function(event){
  $("#customer-create").hide();
  $("#customer-login").show();
  
});
$("body").on("click", ".sticky-title", function(event){
	$(this).toggleClass("active");
});
/*$("body").on("click", ".product-dropdown > span", function(event){
  
  $(".sticky-title > .product-dropdown > span").removeClass("active");
  $(this).addClass("active");
  $(".sticky-price").text($(this).data("price"));
  
  $(".sticky-title > span.title-text").text($(this).children("i").text());
});*/

$("body").on("click", "#shopify-section-sticky-product .sbs_chaeck", function(event){
  $(".stickyCheck").removeClass("active");
  $(this).addClass("active");
  if($(this).hasClass("sbs_one_time")) {
  	$(".sticky-price").text($(".sticky-title span.active").data("default-price"));
  }
  else {
    $(".sticky-price").text($(".sticky-title span.active").data("price"));
  }
});

$("body").on("click", ".product-dropdown > span", function(){
  $(".product-dropdown > span").removeClass("active");
  $(this).addClass("active");
  $(".sticky-price").text($(this).data("price"));
  $("span.title-text").text($(this).children("i").text());
  if($("#shopify-section-sticky-product .sbs_chaeck.active").hasClass("sbs_one_time")) {
    var default_Price = $(".product-dropdown span.active").data("default-price");
    $(".sticky-price").text(default_Price);
  }
  else {
    var default_Price = $(".product-dropdown span.active").data("price");
    $(".sticky-price").text(default_Price);
  }
  
});


$(".quick_view.simpleProduct").each(function(){
  var this_1 = $(this);
  $(this).find("select.no-js-required").children("option").each(function(index){
    if($(this).attr("disabled")) {
      this_1.find("select.single-option-selector option:eq("+index+")").attr("disabled", "disabled");
      if(this_1.find("select.single-option-selector option:eq("+index+")").attr("selected")) {
        this_1.find("select.single-option-selector option:eq("+index+")").removeAttr("selected");
      }
    }
  });
});
if($("body").hasClass("template-product")) {
  refineVariantSelector();
}
//if($("quick_view_btn").length > 0) {
  refineVariantSelector();
//}
function refineVariantSelector() {
  $(".product-form-grid-select").each(function(){
    var this1 = $(this)
    this1.children("select.no-js-required").children("option").each(function(index){
    var text = $(this).text();
    var text1 = text.split("--")[1];
    console.log(text1);
    var optionText = $(".product-form-grid-select .js-required select.single-option-selector option:eq("+index+")").text();
    var optionText = this1.children(".js-required").children("select.single-option-selector").children("option:eq("+index+")").text();
    if(text.indexOf('Sold out') < 0) {
      if(this1.children(".js-required").children("select.single-option-selector").children("option:eq("+index+")").text().indexOf("only") < 0) {
    	this1.children(".js-required").children("select.single-option-selector").children("option:eq("+index+")").text(optionText+" "+text1);
      }
    }
    });
    //console.log("THis"+ text1);
  });
  
  
  /*$(".product-form-grid-select select.no-js-required option").each(function(index){
    var text = $(this).text();
    var text1 = text.split("--")[1];
    console.log(text1);
    var optionText = $(".product-form-grid-select .js-required select.single-option-selector option:eq("+index+")").text();
    if(text.indexOf('Sold out') < 0) {
    	$(".product-form-grid-select .js-required select.single-option-selector option:eq("+index+")").text(optionText+" "+text1);
    }
    
  });*/
}
$("body").on("change", ".simpleProduct .single-option-selector", function(){
  //$(this).children("['selected']").index();
  var selected = $(this).val();
  var ind = $(this).children("option[value='"+selected+"']").index();
  $(this).parent().prev().prev("select.no-js-required").children("option").removeAttr("selected");
  $(this).parent().prev().prev("select.no-js-required").children("option:eq("+ind+")").attr("selected", "selected").trigger("change");
  var variant_id = $(this).parent().prev().prev("select.no-js-required").children("option:eq("+ind+")").data("variant-id");
  //console.log(variant_id);
  $(this).parent().parent().next().children("button").attr("data-product-variant-id", variant_id);
});



var quick_view = {
  addon_option: function(){   
    
   
    
    $('.add_quick_view').on('click', function(){   
      var qty = $(this).closest('.product_subscription').find('input[name="quantity"]').val();
      
      var Subtitle= '';
      Subtitle = $(this).closest('.quk_detail').find('.Subtitle').val();
      
      if($(this).closest('.product_subscription').find('.sbs_one_time').hasClass('active')){
        var id = $(this).closest('.product_subscription').data('pid');
        addItemToCart(id, qty, '1', "Weeks", Subtitle, 0);
      }else{
        var id = $(this).closest('.product_subscription').data('pid');
        var faq = $(this).closest('.product_subscription').find('li.active').data('no');
        addItemToCart(id, qty, faq, "Weeks", Subtitle, 1);
      }
    });
    
    $("body").on("click", ".simpleProduct .product-submit", function(event){
      event.preventDefault();
      var id = $(this).data("product-variant-id");
      var qty = $(this).prev().children(".product-quantity-input").val();
      var subtitle = $(this).data("subtitle");
      console.log(id + " : " + qty);
      simpleaddToCart(id, qty, subtitle);
    });

    $("body").on("click", ".quick_view button.product-submit", function(event){
      setTimeout(function(e){
        $('.quick_view').hide();  
      }, 500);
    });
    
    function simpleaddToCart(variant_id, qty, subtitle) {
      var data = {
            "id": variant_id,
            "quantity": qty,
        	"properties": {
              "Táche": subtitle
            }
          }
      jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() {         
        $('.quick_view').hide();
        referse_cart();  
      }
    });
    }
   
    $("body").on("click", "#shopify-section-sticky-product button", function(){
      //$(".addtocart-button-active").trigger("click");
      //var id = $(".product-dropdown span.active").data("id");
      if(!$(this).hasClass("sold-out") && !$(".product-details-wrapper .product-form.unavailable").length > 0) {
      var id = $(".product-dropdown span.active").children('.freecharge-cnt').find('#rc_duplicate_selector').val();
      var Subtitle = $(".product-dropdown span.active").data("subtitle");

      if($(".sticky-subscribe .sbs_one_time").hasClass("active")) {
        var variant_id = $(".product-dropdown span.active").data("id");
        simpleaddToCart(variant_id, 1, Subtitle);
      }
      else {
        addItemToCart(id, 1, '2', "Weeks", Subtitle, 1);
      }
      /*
      var pid = $(".sticky-title .product-dropdown span.active").data("id");
      var qty = 1;
      if($(".sticky-subscribe .sbs_one_time").hasClass("active")) {
        addItemToCart(pid, qty, '1', "Weeks", 0);
      }
      else {
        addItemToCart(pid, qty, '1', "Weeks", 1);
      }
      */
      }
    });
    
    
   function addItemToCart(variant_id, qty, frequency, unit_type, Subtitle, subscribe) {    
     
     if(subscribe){
       if(typeof Subtitle !== 'undefined'){
        var selling_plan = undefined
        if (document.querySelector('li[class=active]') && document.querySelector('li[class=active]').getAttribute('selling_plan_id')) {
            selling_plan = document.querySelector('li[class=active]').getAttribute('selling_plan_id');
        } else if ($(this).closest('.product_subscription')) {
          selling_plan = $(this).closest('.product_subscription').find('li.active').data('selling_plan');
        }
         var data = {
            "id": variant_id,
            "quantity": qty,
            "properties": {
              "shipping_interval_frequency": frequency,
              "shipping_interval_unit_type": unit_type,
              "Táche": Subtitle
            },
            "selling_plan": selling_plan,
          }
       }else{
          var data = {
            "id": variant_id,
            "quantity": qty,
            "properties": {
              "shipping_interval_frequency": frequency,
              "shipping_interval_unit_type": unit_type
            },
            "selling_plan": selling_plan
          }
        }
        }else{
           if(typeof Subtitle !== 'undefined'){
             var data = {
                "id": variant_id,
                "quantity": qty,
                "properties": {                  
                  "Táche": Subtitle
                },
                "selling_plan": selling_plan
              }
           }else{             
            var data = {
                "id": variant_id,
                "quantity": qty,
                "selling_plan": selling_plan
              }
            }
        }

    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() {   
        referse_cart();
        $('.quick_view').hide();
      }
    });
    
  }
    
   function referse_cart(){
      window.location.href = window.location.href +"?added";
      //$('body').unbind('[data-cart-mini]');
      
      /*jQuery.ajax({
        url: '/cart',       
        success: function(data) {
         var min_cart = $(data).find('.cart-mini-sidebar').html();
          
         $('.cart-mini .cart-mini-sidebar').html(min_cart);
         $('.cart-mini').addClass('cart-mini-open');
          
      	}
      });*/
    }
    
    $('body').on('submit', '.cart-mini-actions__checkout', function(e){
      e.preventDefault();
      /*$.ajax({
        		url: '/cart/update.js',
        		type: 'POST',
        		data: {note: "test note"},
        		success: function(result) { 
            		//window.location.href = window.location.href
                  console.log("Note Added");
        		},
        		error: function(jqxhr, status, exception) {
            		console.log(exception);
        		}
    		});
      return false;
      */
      
      var rechage = false;
      $('.cart-mini-items .cart-mini-item').each(function(){
        var str1 = $(this).find('.cart-mini-item-title').data('name');
        if(str1.indexOf('Auto renew') != -1){
           rechage = true;
        }
      });
                                                 
      // if(rechage){
      //   reChargeProcessCart();
      // }else{
        window.location.href =  '/checkout';
      // }
    });
    
    function reChargeProcessCart() {
        function get_cookie(name){ return( document.cookie.match('(^|; )'+name+'=([^;]*)')||0 )[2] }
        do {
               var token=get_cookie('cart');
        }
        while(token == undefined);	var myshopify_domain=''
        try { var ga_linker = ga.getAll()[0].get('linkerParam') } catch(err) { var ga_linker ='' }
        var myshopify_domain='tachepistachio.myshopify.com';
       
       var  checkout_url= "https://checkout.rechargeapps.com/r/checkout?myshopify_domain="+myshopify_domain+"&cart_token="+token+"&"+ga_linker;
       window.location.href =  checkout_url;
      
    }
    
    
    
  }
}

/*$("body").on("mousedown", ".cart-mini-header", function(event){
  event.stopPropagation();
  
      console.log("close clicked");
      $('.cart-mini').removeClass('cart-mini-open');
  $("html").removeClass("scroll-locked");
});*/



function getQueryStringParameters() {
     var parameters = {}, hash;
     var q = document.URL.split('?')[1];
     if(q != undefined) {
         q = q.split('&');
         for(var i = 0; i < q.length; i++) {
             hash = q[i].split('=');
             parameters[hash[0]] = hash[1];
         }
     }
     return parameters;
 }
function isEmpty(obj) {
 for(var key in obj) {
 if(obj.hasOwnProperty(key))
 return false;
 }
 return true;
}

$(function(){
  quick_view.addon_option();
  if($(".scroll2").length > 0) {
    $(".scroll2").infiniteslide({
       speed: 50,
      clone: 10,
      pauseonhover: false
    });
  }
   $('body').on('click', '.cart-mini-header-close', function(){
       //console.log('gaurav');
       $('.cart-mini').removeClass('cart-mini-open');
    });
  
  
  var parameters = getQueryStringParameters();
  if(isEmpty(parameters) == false) {
    $.each(parameters, function(key, value) {
   	console.log(key, value);
      if(key == "added") {
        //$('.cart-mini').addClass('cart-mini-open');
        document.querySelector('html').classList.toggle('js-ajax-cart-open');  
        var url = window.location.href.split("?")[0];
        console.log(url);
        window.history.pushState({"":"","pageTitle":document.title},"", url);
      }
     
    });
  }
  
  
});






//*** Plugin table-to-div ***//
 (function($) {
    $.fn.table_to_div = function(options) {
      var settings = $.extend({}, {prefix: 'tg',target:''}, options);
      return this.each(function() {   
        var output = "";
        var data = "";
        settings.prefix = settings.prefix+"_";
        columns = [];
        table_target = $(this);
        var tr_count=0;
        //LOOP OVER ALL ROWS
        $(table_target).find('tr').each(function(){
          var col_count = 0;
          //LOW OVER EACH COLUMN IN THE ROW
          $(this).find('th,td').each(function(){        
            var element = $(this).html();        
            if(tr_count ==0){
              //HEADER COLUMN
              columns.push($(this).html());
            }else{
              //CONTENT COLUMN, strip leading and trailing whitespace
              data+= '      <div class="'+settings.prefix+columns[col_count].replace(/\s+/g,'')+' '+settings.prefix+'row">\n';
              data+= '         <label>'+columns[col_count]+'</label>\n';
              data+= '         <span>'+element.replace(/^\s\s*/, '').replace(/\s\s*$/, '')+'</span>\n';
              data+= '      </div>\n'; 
            }   
            col_count++;
          });
          if(tr_count != 0){
            output+='   <div class="'+settings.prefix+tr_count+' '+settings.prefix+'group">\n';
            output+= data;
            output+= '   </div>\n';
            data = "";
          }
          tr_count++;     
        });      
        output = '<div class="'+settings.prefix+'container">\n'+output+'</div>\n';
        if(settings.target.length > 0){
          $(settings.target).html(output);
        }else{
          $(table_target).before(output);
        }        
      });
    };
   if($("#content__customers__billing").length < 1) {
    if($("table.rc_table").length > 0) {
      $("table.rc_table").each(function(){
         $(this).table_to_div();
        $(this).hide();
      });
      $(".tg_Actions").each(function(){
        $(this).children().find(".rc_subscriptions__subscription__item__edit").children("a").text("Edit Subscription");
        //$(this).children().find(".rc_subscriptions__subscription__item__cancel").children("a").text("Cancel Subscription");
        $(this).children().find(".rc_subscriptions__subscription__item__cancel").remove();
      });
      $("h4.purchase-address").each(function(){
        $("<h4 class='address-label'><strong>DELIVERY ADDRESS</strong></h4>").insertBefore($(this));
      });
    }
   }
   if($("#ReCharge-Address").length > 0) {
     if($.trim($("#ReCharge-Address a").text()) == "Edit") {
       $("#ReCharge-Address a").text("Edit Shipping");
     }
   }
   if($("#rc_subscriptions__items__cancel").length > 0) {
     if($.trim($("#rc_subscriptions__items__cancel a").text()) == "Cancel") {
       $("#rc_subscriptions__items__cancel a").text("Cancel Subscription");
     }
   }
   
   
   
  })(jQuery);


$(document).ready(function(){
  
  /**
  * ==============Select Option Start===========
  **/ 
  var selectedVal = $("[data-selected-option]").siblings("select[data-product-option]").find(":selected").val();
  $("[data-selected-option]").text(selectedVal);

  $('select[data-product-option]').on('change', function() {
    $(this).siblings("[data-selected-option]").text(this.value);
    
    var slectedOptionIndex = $(this).prop('selectedIndex');
    $(this).parent().siblings("select[data-variants]").prop('selectedIndex', slectedOptionIndex);
  });

  /**
  * ==============Select Option End===============
  **/
  $('.slider-for-head').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,    
    arrows: false,
    infinite: false,
    autoplay: true,
    autoplaySpeed: 4000,
    lazyLoad: 'progressive',
    responsive: [   
      {
          breakpoint: 768,
          settings: {          
            dots:true,
            infinite: true
          }
        }
    ]
  //   asNavFor: '.pressSlider_new'
  });
  
  
  
  $('.pressSlider_new li:eq(0)').addClass('new_show');
  
  $('.pressSlider_new li').on('click', function(){
    var id = $(this).data('id');
   $('.slider-for-head').slick('slickGoTo', id-1);  
   // $('.pressSlider_new li').removeClass('new_show'); 
   // $(this).addClass('new_show');
  });
 
  

  $('.logo-slide-hor').slick({
      dots: false,
      arrows: false,
       speed: 4000,
  autoplay: true,
  autoplaySpeed: 0,
  cssEase: 'linear',
  slidesToShow: 1,
  slidesToScroll: 1,
  variableWidth: true,
      responsive: [       
        {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          centerMode: true,
        }
      },
        {
        breakpoint: 650,
        settings: {
          slidesToShow: 2,           
          slidesToScroll: 1,
           centerMode: true,
        }
      } 
        
        ]
    
  });
  
   
  
  
  
   $('.slider-for-head').on('afterChange', function(event, slick, currentSlide, nextSlide){
      console.log(currentSlide);
      $('.pressSlider_new li').removeClass('new_show'); 
	  $('.pressSlider_new li:eq('+(currentSlide)+')').addClass('new_show');
   });
  
  
});
	
